export default "__VITE_ASSET__98ad782c__"